import { HttpMethod, IFramework, IWebServiceManager } from "@truckdown/framework";
import { IUserActions } from "./IUserActions";

class UserActions implements IUserActions {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;

    addAnalytics(facts: string[]): Promise<void> {
        var model = {
            facts: facts.map(function (f) {
                return {
                    n: f,
                    v: 1
                };
            })
        };

        let req = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/user/add-analytic',
            method: HttpMethod.PUT
        }, model);

        return new Promise<void>((resolve, reject) => {
            this.manager.send(req)
                .then((res) => {
                    if (res.ok) {
                        resolve();
                    } else {
                        reject(res.status + ' - ' + res.statusText);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    reject(err);
                })
        });
    }
}



export default (framework: IFramework) => {
    framework.registerTransient<IUserActions>('IUserActions', (frm) => {
        return new UserActions(frm);
    });
}
